"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog["default"];
  }
});
var _Dialog = _interopRequireDefault(require("./Dialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }